export default {
      id: "reefer-trailer-usage",
      viewBox: "0 0 28 14",
      url: __webpack_public_path__ + "img/icons.svg#reefer-trailer",
      toString: function () {
        return this.url;
      }
    }